'use client';

import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { useASPInfo } from '@module/queries/asp/query';
import useModalStore from '@module/stores/useModalStore';
import { MODAL_TYPE_PC } from '@module/types/modal/type';
import useIsMounted from '@module/utils/useIsMounted';
import BaseButton from '@pc/components/atoms/button/BaseButton';
const useIsClient = () => {
  return useIsMounted();
};
function StoreButton() {
  const $ = _c(11);
  const pushModal = useModalStore(_temp);
  const {
    loginInfo
  } = useGetLoginInfoQuery();
  const {
    data: aspInfo
  } = useASPInfo();
  const isClient = useIsClient();
  if (!isClient) {
    return null;
  }
  if (aspInfo) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <BaseButton className="mr-4 h-10 rounded-[8px] bg-[#333] text-[15px] text-white" onClick={_temp2}>하트 충전</BaseButton>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] !== loginInfo?.loginInfo.userInfo.isLogin || $[2] !== pushModal) {
      t1 = <>{t0}<BaseButton className="mr-2 h-10 rounded-[8px] bg-[#333] text-[15px] text-white" onClick={() => {
          if (loginInfo?.loginInfo.userInfo.isLogin) {
            pushModal({
              type: MODAL_TYPE_PC.STORE_MODAL,
              options: {
                tab: "item"
              }
            });
          } else {
            pushModal({
              type: MODAL_TYPE_PC.AUTH_MODAL
            });
          }
        }}>아이템 구매</BaseButton></>;
      $[1] = loginInfo?.loginInfo.userInfo.isLogin;
      $[2] = pushModal;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t0;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      content: "\uC0C1\uC810"
    };
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== loginInfo?.loginInfo.userInfo.isLogin || $[6] !== pushModal) {
    t1 = () => {
      if (loginInfo?.loginInfo.userInfo.isLogin) {
        pushModal({
          type: MODAL_TYPE_PC.STORE_MODAL
        });
      } else {
        pushModal({
          type: MODAL_TYPE_PC.AUTH_MODAL
        });
      }
    };
    $[5] = loginInfo?.loginInfo.userInfo.isLogin;
    $[6] = pushModal;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-[36px] w-[36px] animate-floating bg-50% bg-icon-heart-store bg-size-24 bg-no-repeat" />;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1) {
    t3 = <BaseButton tooltip={t0} variant="ghost" size="none" className="flex h-[48px] w-[48px] items-center justify-center rounded-full hover:bg-menuHover focus:outline-none" onClick={t1}>{t2}</BaseButton>;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp2() {
  return SettingConfig.aspUtils?.goCharge();
}
function _temp(state) {
  return state.pushModal;
}
export default StoreButton;